@for (agent of agents(); track agent.agentCode) {
  <mat-checkbox
    class="min-w-0 shrink-0"
    [attr.data-id]="'agent-toggle-' + agent.agentCode"
    [checked]="agent.checked"
    (change)="toggled.emit(agent.agentCode)"
    color="primary"
  >
    <span class="flex min-w-0 items-center gap-2">
      <rma-profile-avatar [avatar]="agent.avatarImage" [size]="32" [lazyLoad]="false" />
      <span class="line-clamp-1 whitespace-nowrap md:whitespace-normal">{{ agent.agentName }}</span>
    </span>
  </mat-checkbox>
}
